import { IServicePackage } from '../entities/IServicePackage';
import { httpClient } from './helper/httpClient';

export interface ICreateServicePackageParams {
  name: string;
  description?: string;
  price: number;
  imageUrl?: string;
  serviceIds: string[];
}

export interface IUpdateServicePackageParams {
  name?: string;
  description?: string;
  price?: number;
  imageUrl?: string | null;
  serviceIds?: string[];
}

class ServicePackageService {
  private _baseURL = 'service-packages';

  getAll(options?: {
    archived?: 'only' | 'include' | 'exclude';
  }): Promise<IServicePackage[]> {
    return httpClient.get<null, IServicePackage[]>(this._baseURL, {
      params: options?.archived ? { archived: options.archived } : undefined,
    });
  }

  getById(id: string): Promise<IServicePackage> {
    return httpClient.get<null, IServicePackage>(`${this._baseURL}/${id}`);
  }

  create(data: ICreateServicePackageParams): Promise<IServicePackage> {
    return httpClient.post<null, IServicePackage>(this._baseURL, data);
  }

  update(
    id: string,
    data: IUpdateServicePackageParams,
  ): Promise<IServicePackage> {
    return httpClient.patch<null, IServicePackage>(
      `${this._baseURL}/${id}`,
      data,
    );
  }

  delete(id: string): Promise<void> {
    return httpClient.delete(`${this._baseURL}/${id}`);
  }

  restore(id: string): Promise<void> {
    return httpClient.post(`${this._baseURL}/${id}/restore`);
  }
}

export default new ServicePackageService();
